import { APIClient } from "./axiosClient";

type GiftCardProductPayload = {
  productName?: string | null;
  productCode?: string | null;
  redemptionMerchantId?: number | null;
  brandId?: number | null;
  countryId?: number | null;
  platformCategoryId?: number | string | null;
  programCategoryId?: number | string | null;
  productType?: string | null;
  pageNumber?: number;
  pageSize?: number;
  sortOrder?: string;
  sortBy?: string;
};

const DEFAULT_GIFT_CARD_PAYLOAD: GiftCardProductPayload = {
  productName: null,
  productCode: null,
  redemptionMerchantId: null,
  brandId: null,
  countryId: null,
  platformCategoryId: null,
  programCategoryId: null,
  productType: "GIFT_CARD",
  pageNumber: 0,
  pageSize: 10,
  sortOrder: "desc",
  sortBy: "createdDate",
};

export class ProductApi {
  static fetchGiftCardProducts(payload: GiftCardProductPayload = DEFAULT_GIFT_CARD_PAYLOAD) {
    return APIClient(
      "/product/getGiftCardProducts",
      { ...DEFAULT_GIFT_CARD_PAYLOAD, ...payload },
      { requestType: "post" }
    );
  }

  static fetchMerchandiseProducts(payload = {
    productName: null,
    productCode: null,
    redemptionMerchantId: null,
    brandId: null,
    countryId: null,
    platformCategoryId: null,
    productType: "MERCHANDISE",
    pageNumber: 0,
    pageSize: 10,
    sortOrder: "desc",
    sortBy: "createdDate"
  }) {
    return APIClient(
      "/product/getGiftCardProducts",
      payload,
      { requestType: "post" }
    );
  }

  static fetchFlightBookingProducts(payload = {
    productName: null,
    productCode: null,
    redemptionMerchantId: null,
    brandId: null,
    countryId: null,
    platformCategoryId: null,
    productType: "FLIGHT_BOOKING",
    pageNumber: 0,
    pageSize: 10,
    sortOrder: "desc",
    sortBy: "createdDate"
  }) {
    return APIClient(
      "/product/getGiftCardProducts",
      payload,
      { requestType: "post" }
    );
  }

  static fetchHotelBookingProducts(payload = {
    productName: null,
    productCode: null,
    redemptionMerchantId: null,
    brandId: null,
    countryId: null,
    platformCategoryId: null,
    productType: "HOTEL_BOOKING",
    pageNumber: 0,
    pageSize: 10,
    sortOrder: "desc",
    sortBy: "createdDate"
  }) {
    return APIClient(
      "/product/getGiftCardProducts",
      payload,
      { requestType: "post" }
    );
  }
} 